import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Modal from "../Modal";
import { Controller, useForm } from "react-hook-form";
import { InputTextarea } from "primereact/inputtextarea";
import "./ModalEditerCommentaire.scss";
import axios from "axios";
import { useEffect } from "react";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";

const ModalEditerCommentaire = ({ visible, setVisible, auth }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      content: visible.content,
    },
  });

  const editComment = (data) => {
    var result = undefined;
    axios
      .put(
        `${process.env.REACT_APP_BASE_URL_API}/publication_comments/` +
          visible.id,
        data,
        {
          headers: auth.token
            ? {
                accept: "application/json",
                Authorization: `Bearer ${auth.token}`,
              }
            : {
                accept: "application/json",
              },
        }
      )
      .then((response) => (result = response))
      .catch((error) => (result = error.response.data.detail))
      .finally(() => {
        if (result && result.status === 200)
          setVisible({ state: false, result: result });
        else setVisible({ state: false, result: result });
      });
  };

  /**
   *  Fonction qui va remplir la propriété publication avec la publication actuelle
   * @param {{content: string, publication: string}} data données du formulaire
   * @returns données du formulaire avec champ sourceGroup renseigné
   */
  const assignPublication = (data) => {
    data = {
      ...data,
      publication: "/api/publications/" + visible.publicationId.toString(),
    };
    return data;
  };

  const onSubmit = (data) => {
    data = assignPublication(data);
    editComment(data);
  };

  /**
   * Affichage d'une erreur si nécessaire dans le formulaire
   * @param {String} name nom du champ
   * @returns {JSX.Element}
   */
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  useEffect(() => {
    setValue("content", visible.content);
  }, [visible.content]);

  return (
    <>
      <Modal
        visible={visible.state}
        setVisible={() => setVisible({ ...visible, state: false })}
        header="Modifier le commentaire"
        height="fit-content"
        width="80%"
        className="modal modal_edition-commentaire"
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={"edition_commentaire__form"}
        >
          <label htmlFor="content">Modifiez le commentaire</label>
          <Controller
            name="content"
            control={control}
            rules={{
              required: "Veuillez renseigner le contenu du commentaire",
            }}
            render={({ field }) => (
              <InputTextarea
                {...field}
                className="edition_commentaire__form-content"
                placeholder="Laisser un commentaire"
                cols={30}
                autoResize
              />
            )}
          />
          {getFormErrorMessage("content")}
          <div className="edition_commentaire__form-buttons">
            <BtnBleu btnTexte="Modifier" />
            <BtnBlanc
              btnTexte="Annuler"
              action={"button"}
              btnAction={() => setVisible({ ...visible, state: false })}
            />
          </div>
        </form>
      </Modal>
    </>
  );
};

ModalEditerCommentaire.propTypes = {
  visible: PropTypes.object.isRequired,
  setVisible: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  groups: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  groups: state.groups,
});

export default connect(mapStateToProps)(ModalEditerCommentaire);
